import { Popper, ClickAwayListener, Fade, Box } from "@mui/material";
import {
  useState,
  useEffect,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";

export const ButtonWithPopper = ({
  showPopper,
  popperText,
  renderButton,
}: {
  showPopper: boolean;
  popperText: string;
  renderButton: (
    setPopperAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>,
  ) => ReactNode;
}) => {
  const [popperOpen, setPopperOpen] = useState(false);
  const [popperAnchorEl, setPopperAnchorEl] = useState<null | HTMLElement>(
    null,
  );

  // Copied from https://mui.com/material-ui/react-popper/
  // I don't understand it
  const canBeOpen = popperOpen && Boolean(popperAnchorEl);
  const id = canBeOpen ? "transition-popper" : undefined;

  useEffect(() => {
    if (showPopper) {
      setPopperOpen(true);
      setTimeout(() => setPopperOpen(false), 5000);
    } else {
      setPopperOpen(false);
    }
  }, [showPopper]);

  return (
    <>
      {renderButton(setPopperAnchorEl)}
      <Popper
        id={id}
        open={popperOpen}
        anchorEl={popperAnchorEl}
        transition
        modifiers={[{ name: "offset", options: { offset: [0, 5] } }]}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={() => setPopperOpen(false)}>
            <Fade {...TransitionProps} timeout={350}>
              <Box
                sx={{
                  border: 1,
                  p: 1,
                  borderRadius: 1,
                  bgcolor: "success.dark",
                }}
              >
                {popperText}
              </Box>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
};
